import { Button } from '@cargoflow/ui/components/button'
import { useNavigate, useRouter } from '@tanstack/react-router'

export function NotFoundError() {
  const navigate = useNavigate()
  const { history } = useRouter()
  return (
    <div className="h-svh">
      <div className="m-auto flex h-full w-full flex-col items-center justify-center gap-3 px-4 text-center">
        <span className="font-mono text-sm font-medium tabular-nums text-muted-foreground">
          404
        </span>
        <h1 className="font-manrope text-3xl font-extrabold tracking-tight sm:text-4xl">
          Page not found
        </h1>
        <p className="max-w-sm text-sm text-muted-foreground">
          The page you're looking for does not exist or might have been removed.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-4">
          <Button variant="outline" onClick={() => history.go(-1)}>
            Go Back
          </Button>
          <Button onClick={() => navigate({ to: '/' })}>Back to Home</Button>
        </div>
      </div>
    </div>
  )
}
